module.exports = __webpack_public_path__ + "img/box6-11.40309c45.png";